export const PROFILE = "api/profile";
export const CHANGE_PASSWORD = "api/changePassword";
export const MY_RATING = "api/myRatings";
export const NOTIFICATION = "api/notificationList";
export const ORDER_DETAIL = "api/orderDetail";
export const MYORDER_LIST = "api/myOrderList";
export const USER_DASHBOARD = "api/userDashboard";
export const ADD_BOOKMARK = "api/bookmark";
export const UN_BOOKMARK = "api/unBookmark";
export const BOOKMARK_LIST = "api/bookmarkList";
export const CLEAR_TUS = "api/clearTus";
export const FORGOT = "api/forgot";
export const VENDOR_DASHBOARD = "api/vendorDashboard";
export const DELIVERY_CHARGES = "api/addDeliveryCharges";
export const STOREDELIVERY_CHARGES = "api/storeDeliveryCharges";
export const ADD_OFFER = "api/offer";
export const DELETE_OFFER = "api/deleteOffer";
export const OFFER_LIST = "api/myOfferList";
export const ORDER_STATUS = "api/changeOrderStatus";
export const SEND_ORDERSTATUS = "api/sendOrderStatusNotification";
export const ORDERDETAIL_VENDOR = "api/orderDetailVendor";
export const ORDERLIST_VENDOR = "api/orderListVendor";
export const TRANSACTION = "api/orderTransactions";
export const GET_FAQ = "api/getFAQ";
export const GET_PAGE = "api/getPage";
export const PRODUCTRATING_LIST = "api/productRatingList";
export const RATING = "api/rating";
export const ADD_VAT = "api/vat";
export const DELETE_ACCOUNT = "api/deleteAccount";
export const DELETE_VAT = "api/deleteVat";
export const VAT_LIST = "api/vatList";
export const DELETE_PRODUCT = "api/deleteProduct";
export const STORE_OFFER_LIST = "api/offerList";
export const RESET_PASSWORD = "api/resetPassword";
export const MANUALSUB_CATEGORY = "api/addManualSubCategory";
export const ADD_PRODUCT = "api/product/v2";
export const LIST_UNIT = "api/listUnit";
export const PRODUCT_DETAIL = "api/productDetail";
export const PRODUCT_LIST = "api/productList";
export const SUBCATEGORY_LIST = "api/subCategoryList";
export const APPLY_COUPONCODE = "api/applyCouponCode";
export const CART_DETAIL = "api/cartDetail";
export const STOREOFFER_LIST = "api/storeOfferList";
export const NOTIFICATIONCOUNT_UPDATE = "api/notificationCountUpdate";
export const ADD_PRODUCT_CART = "api/cart";
export const CART_CLEAR = "api/cartClear";
export const CART_ITEM_DELETE = "api/cartItemDelete";
export const RATING_LIST = "api/ratingList";
export const STORE_VISIT_NOTIFICATION = "api/storeVisitNotification";
export const WISH = "api/wish";
export const WISH_LIST = "api/wishList";
export const STORE_DETAIL = "api/storeDetail";
export const WISH_REMOVE = "api/wishRemove";
export const SEARCH = "api/search";
export const STORE_SEARCH = "api/storeSearch";
export const SERVICES = "api/services";
export const CREATE_STORE = "api/store";
export const ADD_MULTIPLE_PRODUCTS = "api/addMultipleProducts";
export const LIST_MASTER_PRODUCTS = "api/listMasterProducts";
export const ADD_CHAT_GROUP = "api/addChatGroup";
export const MY_CHAT_LIST = "api/myChatList";
export const READ_MSG_NOTIFICATION = "api/readMsgNotification";
export const SEND_MSG_NOTIFICATION = "api/sendMsgNotification";
export const SEND_NOTIFICATION = "api/sendNotification";
export const UPDATE_LANGUAGE = "api/update-language";
export const REGISTER_WITH_OTP = "api/registerWithOTP";
// cab booking api
export const DRIVER_DETAIL = "api/driverDetail";
export const LIST_VEHICLE = "api/listVehicle";
export const DRIVER_DASHBOARD = "api/driverDashboard";
export const BOOKING_STATUS = "api/changeBookingStatus";
export const API_SEND_BOOKING_STATUS_NOTIFICATION = "api/SendBookingStatusNotification";
export const MY_RIDES = "api/myRides";
export const AIRPORT_LIST = "api/getAirports";
export const SEARCH_DRIVER = "api/searchDriver";
export const SEARCH_NEW_DRIVER = "api/searchDriverNew";
export const UPDATE_LAT_LNG = "api/updateLatLng";
export const BOOKING = "api/booking";
export const GET_DISTANCE = "api/getDistance";
export const PRICING_VEHICLE = "api/addPricingForVehicle";
export const DELETE_VEHICLE_PACKAGE = "api/deleteVehiclePackage";
export const PACKAGE_LIST = "api/vehiclePackageListing";
export const CREATE_DRIVER = "api/vehicle";
export const SENDBOOK_NOTIFICATION = "api/sendBookingNotification"
